import React from "react";
import CurrentWeather from "./CurrentWeather";
import Footer from "./Footer";
import "./App.css";
import "./styles.css";

function App() {
  return (
    <div className="App">
      <div className="container">
        <div className="card p-1 shadow-lg rounded centerElement">
          <CurrentWeather />
          <Footer />
        </div>
      </div>
      <script src="src/index.js"></script>
    </div>
  );
}

export default App;
